import { Module } from 'vuex'

import bookings, { Action as BookingAction, Mutation as BookingMutation } from './bookings'

import offers, { Action as OfferAction, Mutation as OfferMutation } from './offers'

export interface ModuleState {}

export type RootState = any

type Action = BookingAction | OfferAction

type Mutation = BookingMutation | OfferMutation

export const interviewModule: Module<ModuleState, RootState> = {
  actions: {
    fetch({ dispatch }) {
      return Promise.all([
        dispatch<Action>({ type: 'bookings/fetch' }),
        dispatch<Action>({ type: 'offers/fetch' }),
      ])
    },
  },
  modules: {
    bookings: {
      namespaced: true,
      ...bookings,
    },
    offers: {
      namespaced: true,
      ...offers,
    },
  },
}

export default interviewModule

export { Action, BookingAction, OfferAction, Mutation, BookingMutation, OfferMutation }
